import { Component, computed, input, output } from '@angular/core';
import { Hitl } from 'api-clients/ai-api-client';
import { EzCardComponent } from 'src/shared/ez-card/ez-card.component';

/**
 * Inline Yes/No(/Edit) confirmation cards for a pending EVA HITL action (EZ-186935), driven by
 * `hitl.options`. Selecting an option locks the set; the parent dispatches the choice.
 */
@Component({
  selector: 'ez-eva-action-confirmation',
  imports: [EzCardComponent],
  templateUrl: './eva-action-confirmation.component.html',
  styleUrl: './eva-action-confirmation.component.scss',
})
export class EvaActionConfirmationComponent {
  protected readonly hitl = input.required<Hitl>();
  protected readonly selectedOption = input<string | undefined>(undefined);
  protected readonly optionSelected = output<string>();

  protected readonly options = computed(() => this.hitl().options ?? []);
  protected readonly isLocked = computed(() => this.selectedOption() != null);

  protected onOptionClick(option: string): void {
    if (this.isLocked()) {
      return;
    }
    this.optionSelected.emit(option);
  }
}
